import { Link } from 'react-router-dom';
import useClickOutside from '../hooks/useClickOutside';
import { useState } from 'react';

const UserMenu = ({ currentUser, onLogoutRequest }) => {
    const [isOpen, setIsOpen] = useState(false);  

    const userMenuRef = useClickOutside(() => {
        setIsOpen(false);
    });  
    
    const getProfileSrc = (pic) => {
        if (!pic) return "/public/noAvatar.png";
        return pic.startsWith("http") ? pic : "/upload/" + pic;
    };

    return (
        <div className="user" ref={userMenuRef}>
            <img 
                src={getProfileSrc(currentUser.profilePic)} 
                alt="" 
                onClick={() => setIsOpen(!isOpen)}
                style={{ cursor: 'pointer' }}
            />

            <span 
                onClick={() => setIsOpen(!isOpen)} 
                style={{ cursor: 'pointer', userSelect: 'none' }}
            >
                {currentUser.name}
            </span>

            {isOpen && (
                <div className="dropdownMenu">
                    <Link 
                        to={`/profile/${currentUser.id}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                        onClick={() => setIsOpen(false)} 
                    >
                        <button className="function">My profile</button>
                    </Link>

                    <Link 
                        to="/settings" 
                        // Sửa dòng này style="{{" textDecoration: "none", color: "inherit" }} onClick="{()"> setIsOpen(false)}
                    >
                        <button className="function">
                            Settings
                        </button>
                    </Link>

                    <Link 
                        to={`/profile/${currentUser.id}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                        onClick={() => setIsOpen(false)}
                    >
                        <button className="function">
                            Help & Support
                        </button>
                    </Link>

                    <hr />

                    <button className="logout" onClick={(e) => {
                        e.stopPropagation(); 
                        setIsOpen(false); 
                        onLogoutRequest();
                    }}>
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};
export default UserMenu;